<template>
  <div>
    <b-modal
      :id="`modal-image-viewer-single${id}`"
      modal-class="modal-image-viewer"
      ok-title="OK"
      cancel-variant="outline-secondary"
      scrollable
      title="圖片"
      title-class="font-weight-bolder"
      body-class="common_modal "
      hide-header
      hide-footer
      centered
      size="lg"
    >
    <font-awesome-icon @click="hide" class="close-button"
      style="font-size: 25px" icon="fa-solid fa-circle-xmark" />
      <div class="text-center w-100">{{ imageData.name}}</div>
        <embed
          v-if="imageData.type == 'application/pdf'"
          id="pdfcontainer"
          class="pdf"
          :src="imageData.src"
          type="application/pdf"
        />
        <img
          v-else
          class="d-block image"
          :src="imageData.src"
          alt="image slot"
        />
      <!-- form -->
    </b-modal>
  </div>
</template>
  
  <script>
import { BModal, VBModal } from "bootstrap-vue";

export default {
  components: {
    BModal,
  },
  directives: {
    "b-modal": VBModal,
  },
  methods: {
    hide() {
      this.$bvModal.hide(`modal-image-viewer-single${this.id}`);
    },
  },
  props: {
    id:{
      type: String,
      default:""
    },
    imageData: {
    },
  },
  computed: {
  },
};
</script>
  
<style lang="scss">
.close-button{
  position: absolute;
  top:3px;
  right:3px;
}
// 只作用於預覽視窗內，避免影響列表中的 PDF 縮圖
.modal-image-viewer {
  .pdf {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: calc(100vh - 12rem);
    min-height: 320px;
    border: 0;
  }
}

</style>
  
  